export const formatCurrency = (number) =>
  typeof number === 'number'
    ? number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
    : number

export const formatDate = (inputDate) => {
  if (!inputDate) {
    return ''
  }
  const date = new Date(inputDate)
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
}

export const formatPercentage = (number) =>
  typeof number === 'number' ? `${number.toFixed(1)}%` : number

export const getErrorMessage = (err, fallback = 'Something went wrong') => {
  const apiMessage = err?.response?.data?.message
  if (apiMessage) return apiMessage
  if (!err?.response) {
    if (err?.message === 'Network Error') {
      return 'Unable to reach the server. Check your connection and try again.'
    }
    if (err?.message) return err.message
  }
  return fallback
}

export const ToastPopUp = (name, severity, summary, msg) => {
  if (name?.current) {
    name.current.show({
      severity: severity,
      summary: summary,
      detail: msg,
    })
  } else {
    console.warn('Toast reference is not available', { severity, summary, msg })
  }
}
